import { Grid } from "@mui/material";
import React from "react";
import "./card.css";
import { ITwoColumnCard } from "./ICard";

export default function TwoColumnCard({
  cashAmount,
  saleAmount,
  customerWalletAmount,
  totalSettlementAmount,
  creditAmount,
  saleItemsFeeAmount,
  repaymentFeeAmount,
  supplierSideLoanFeeAmount,
  taxAmount,
}: ITwoColumnCard) {
  return (
    <>
      <Grid container spacing={2} className="boxTowColumn">
        <Grid item xs={6} className="grid-item">
          مبلغ اعتبار:
        </Grid>
        <Grid item xs={6} className="grid-item grid-item-left">
          {creditAmount?.toLocaleString()} ریال
        </Grid>
        <Grid container xs={12} className="grid-item">
          <Grid
            item
            xs={6}
            style={{
              color: "#9aafc4",
              paddingTop: "1em",
            }}
          >
            مبلغ نقدی:
          </Grid>
          <Grid
            item
            xs={6}
            className="grid-item-left"
            style={{
              paddingTop: "1em",
              paddingLeft: "1.5em",
              background: "#F9FAFC",
            }}
          >
            {cashAmount?.toLocaleString()} ریال
          </Grid>
          {cashAmount > 0 && (
            <Grid item xs={12}>
              <div
                style={{
                  color: "#FB8C00",
                  fontSize: ".95rem",
                  fontWeight: "bold",
                  paddingTop: "0.5em",
                }}
              >
                توجه داشته باشید این مبلغ باید توسط فروشنده به صورت نقدی از
                خریدار دریافت شود.
              </div>
            </Grid>
          )}
        </Grid>
        <Grid
          item
          xs={6}
          style={{ background: "#F9FAFC" }}
          className="grid-item"
        >
          جمع کل فاکتور:
        </Grid>
        <Grid
          item
          xs={6}
          style={{ background: "#F9FAFC" }}
          className="grid-item grid-item-left"
        >
          {saleAmount?.toLocaleString()} ریال
        </Grid>
      </Grid>
      {(saleItemsFeeAmount !== undefined && saleItemsFeeAmount > 0) ||
      (supplierSideLoanFeeAmount !== undefined &&
        supplierSideLoanFeeAmount > 0) ||
      (repaymentFeeAmount !== undefined && repaymentFeeAmount > 0) ||
      (taxAmount !== undefined && taxAmount > 0) ? (
        <Grid
          container
          spacing={2}
          className="boxTowColumn"
          style={{ marginTop: "1rem" }}
        >
          {saleItemsFeeAmount !== undefined && saleItemsFeeAmount > 0 && (
            <>
              <Grid item xs={6} className="grid-item">
                کارمزد پذیرندگی:
              </Grid>
              <Grid item xs={6} className="grid-item grid-item-left">
                {saleItemsFeeAmount?.toLocaleString()} ریال
              </Grid>
            </>
          )}
          {supplierSideLoanFeeAmount !== undefined &&
            supplierSideLoanFeeAmount > 0 && (
              <>
                <Grid item xs={6} className="grid-item">
                  کارمزد صدور تسهیلات:
                </Grid>
                <Grid item xs={6} className="grid-item grid-item-left">
                  {supplierSideLoanFeeAmount?.toLocaleString()} ریال
                </Grid>
              </>
            )}
          {repaymentFeeAmount !== undefined && repaymentFeeAmount > 0 && (
            <>
              <Grid item xs={6} className="grid-item">
                کارمزد اقساط:
              </Grid>
              <Grid item xs={6} className="grid-item grid-item-left">
                {repaymentFeeAmount?.toLocaleString()} ریال
              </Grid>
            </>
          )}
          {taxAmount !== undefined && taxAmount > 0 && (
            <>
              <Grid item xs={6} className="grid-item">
                مالیات بر ارزش افزوده:
              </Grid>
              <Grid item xs={6} className="grid-item grid-item-left">
                {taxAmount?.toLocaleString()} ریال
              </Grid>
            </>
          )}
        </Grid>
      ) : null}

      {totalSettlementAmount ? (
        <Grid
          container
          spacing={2}
          className="boxTowColumn"
          style={{ marginTop: "1rem", backgroundColor: "#FFEED9" }}
        >
          <Grid item xs={6} className="grid-item">
            مبلغ تسویه حساب با پذیرنده:
          </Grid>
          <Grid item xs={6} className="grid-item grid-item-left">
            {totalSettlementAmount?.toLocaleString()} ریال
          </Grid>
        </Grid>
      ) : null}
    </>
  );
}
